export default __webpack_public_path__ + "static/media/connect-workers.87cef34b.svg";